module.exports = __webpack_public_path__ + "static/img/zhengshu1.a7165cab.webp";